import React, { useContext } from "react";
import { GlobalContext } from "./../Context";
import removeQueryParams from "./../Global/removeQueryParams";
import "./BackButton.scss";

export const BackButton = () => {
  const globalContext = useContext(GlobalContext);
  const {
    setCurrentPopUp,
    setBranches,
    setMarkersVisibility,
    setResultsState,
    setFiltersVisibility,
    backButtonVisibility,
    setBackButtonVisibility,
    backButtonType,
    setFilterCardState,
    setCategoryFilters,
    setCategorySelected,
    currentPopUp,
  } = globalContext;

  const handleReturn = () => {
    switch (backButtonType) {
      case "search":
        setResultsState(false);
        setBranches([]);
        setFiltersVisibility(true);
        setMarkersVisibility(false);
        setCurrentPopUp(false);
        setBackButtonVisibility(false);
        removeQueryParams();
        setFilterCardState("close");
        setCategorySelected(null);
        break;
      case "results":
      default:
        setCurrentPopUp(false);
        setBackButtonVisibility(false);
        setResultsState(false);
        setBranches([]);
        setFiltersVisibility(true);
        setMarkersVisibility(false);
        setCurrentPopUp(false);
        removeQueryParams();
        setFilterCardState("close");
        setCategoryFilters(null);
        setCategorySelected(null);
        break;
    }
  };

  return (
    <button
      className={`card-teaser-list__back ${
        backButtonVisibility ? "card-teaser-list__back--open" : ""
      } ${currentPopUp ? "card-teaser-list__back--multiple" : ""}`}
      onClick={handleReturn}
    >
      Volver a la búsqueda
    </button>
  );
};
